<template>
  <svg ref="svgRef" :class="['icon', rotate]">
    <use :xlink:href="`#${id}`"/>
  </svg>
</template>

<script>
export default {
	name: 'Icon',
	props: {
		id: {
      type: String,
      required: true
    },
    rotate: {
      type: String,
      default: ''
    }
	}
}
</script>

<style>
.icon {
  display: inline-block;
  width: 1em;
  height: 1em;
  fill: currentColor;
  text-decoration: inherit;
}
</style>
